import { Skeleton } from '@chakra-ui/react';

export const SortingSelectSkeleton = () => (
    <Skeleton width="298px" height="50px" display={{ base: 'none', md: 'block' }} />
);
